export const Icon = ({ className = '', icon }: { className?: string; icon: string }) => (
  <i className={`icon ${icon} ${className}`} />
)
